import React from 'react';
import { NodeProps, useReactFlow } from 'reactflow';
import { operationType } from '../../../../../services/types';
import { SettingsBlock, settingsDataType } from '../../../../settingsBlock';
import { ExpandedBlock } from '../../../expanded';
import { updateNodeValue } from '../../../../../services/method';
import { Main, Styled } from './style';
import { TextInput } from '../../../../form/textInput';
import { Textarea } from '../../../../form/textarea';
import { IoCheckmarkCircleOutline, IoWarningOutline } from 'react-icons/io5';
import { AuthenticateSelect } from '../../../../auth/select';

type TwilioSendSmsProps = NodeProps<operationType> & {
    setChildMinimize?: (fn: (id: string) => void) => void;
    setChildSettings?: (fn: (id: string) => void) => void;
};

export function TwilioSendSms({
    id,
    data,
    setChildMinimize,
    setChildSettings,
}: TwilioSendSmsProps) {
    const { setNodes } = useReactFlow();
    const [settings, setSettings] = React.useState<settingsDataType>({ isToggle: false });
    const [isExpanded, setIsExpanded] = React.useState(false);

    React.useEffect(() => {
        if (setChildMinimize) setChildMinimize(() => setIsExpanded((p) => !p));
        if (setChildSettings) setChildSettings(() => setSettings((p) => ({ ...p, isToggle: !p.isToggle })));
    }, [setChildMinimize, setChildSettings]);

    const handleChangeInput = (
        e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
        keyRef?: string
    ) => keyRef && updateNodeValue(id, setNodes, { [keyRef]: e.target.value });

    const isWarning = !data.value?.connection;

    return (
        <>
            <SettingsBlock nodeId={id} data={settings} setData={setSettings} />
            <Main>
                {isWarning ? (
                    <>
                        <div id="warning"></div>
                        <span id="warningIcon"><IoWarningOutline size={21} /></span>
                    </>
                ) : data.output ? (
                    <>
                        <div id="ran"></div>
                        <span id="ranIcon"><IoCheckmarkCircleOutline size={21} /></span>
                    </>
                ) : null}

                {isExpanded && (
                    <ExpandedBlock
                        data={{ id, ...data }}
                        handleClose={() => setIsExpanded(false)}
                        style={{ minWidth: '420px' }}
                        isWarning={isWarning}
                    >
                        <Styled> 
                            <AuthenticateSelect
                                type="twilio"
                                defaultId={data.value?.connection?._id || data.value?.connectionId}
                                handleAuthenticate={(type, connection) => {
                                    if (type === 'add') {
                                        const connectionId = connection._id || connection.id;
                                        updateNodeValue(id, setNodes, { connection, connectionId });
                                    } else {
                                        updateNodeValue(id, setNodes, { connection: null, connectionId: null });
                                    }
                                }}
                                withLine={ !data.value?.connection }
                                background={data.background}
                            />

                            {!data.value?.connection && (
                                <>
                                        <TextInput
                                            keyRef="phoneNumber"
                                            value={data.value?.phoneNumber || ''}
                                            placeholder="Enter phone number"
                                            handleChange={handleChangeInput}
                                        />

                                    <Textarea
                                        keyRef="message"
                                        value={data.value?.message || ''}
                                        placeholder="Enter your SMS message or use variables like {{ $block.googleGemini-1.output }}"
                                        handleChange={handleChangeInput}
                                    />


                                </>
                            )}
                        </Styled>
                    </ExpandedBlock>
                )}
            </Main>
        </>
    );
}